import "../../../../styles/claim.scss";
import Icon, { iconColor, iconTypes } from "../../../common/components/Icon.jsx";

import React, {Component} from "react";
import DragAndDrop from "../../../common/components/DragAndDrop";
import {Localization} from "../../../common/util/localization.jsx";
import Modal from "../../../common/components/Modal.jsx";
import PropTypes from "prop-types";


class BtnRemoveFile extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onClickRemove = this.onClickRemove.bind(this);
    }
    onClickRemove() {
        const {
            claim,
            editClaim,
            file,
        } = this.props;
        editClaim({
            attachments: claim.attachments.filter( (item) => item!==file),
        });
    }
    render() {
        const {
            file,
        } = this.props;
        return (
            <button className="btn-tiny icon" onClick={this.onClickRemove}> 
                <Icon type={iconTypes.x} color={iconColor.red} />
                {file.name}
            </button>
        );
    }
}
BtnRemoveFile.propTypes = {
    file: PropTypes.object.isRequired,
    claim: PropTypes.object.isRequired,
    editClaim: PropTypes.func.isRequired,
};


class ClaimAttachmentsModal extends Component {
    constructor(props){
        super(props);

        //const fileNames = props.claim.attachments.map( (file) => file.name);
        this.state = { files: props.claim.attachments, error: "" };

        this.handleFiles = this.handleFiles.bind(this);
        this.onClickRemove = this.onClickRemove.bind(this);
        this.handleError = this.handleError.bind(this);
    }

    handleFiles(files) {
        const {
            editClaim
        } = this.props;
        //creates a new variable to force a render()
        const f = [].concat(this.state.files || []);
        for(let i=0; i<files.length; i++){
            if( files[i].name ){
                f.push(files[i]);
            }
        }
        editClaim({
            attachments: f,
        });

        this.setState({ files: [...this.state.files, ...files]}); 
    }

    handleError(error) {
        this.setState({ error: error}); 
    }

    onClickRemove(e) {
        const {
            editClaim,
        } = this.props;
        const fileName = e.target.id;
        const newFiles = this.state.files.filter((f) => f.name!=fileName);

        editClaim({ attachments: newFiles});
        
        this.setState({ files: newFiles}); 
    }

    render() {
        const {
            localization,
            onCloseModal,
        } = this.props;
        return(
            <Modal onCloseModal={onCloseModal} width={400}>
                <div className="modal-wrapper">
                    <div className="header bottom-border">
                        <div className="header-left">
                            <div className="header-detail">{"Last opp vedlegg"}</div>
                        </div>
                        <button className="btn circular" style={{float:"right"}} onClick={onCloseModal}>
                            <Icon type={iconTypes.x} color={iconColor.red}/>
                        </button>
                    </div>
                    <div className="files">
                        {/* { this.state.files.length } */}
                        {/* {claim.attachments && claim.attachments.map( (file) => (
                            <BtnRemoveFile key={file.name} file={file} claim={claim} editClaim={editClaim} />
                        ))} */}
                        {this.state.files.map( (file) => (
                            <button key={file.name} id={file.name} className="btn-tiny icon" onClick={this.onClickRemove}> 
                                <Icon type={iconTypes.x} color={iconColor.red} />
                                {file.name}
                            </button>                            
                        ))}
                        { this.state.error && (<div className="fileserror">{this.state.error}</div> )}
                    </div>
                    <div className="dropArea-wrapper">
                        <DragAndDrop localization={localization} handleFiles={this.handleFiles} disabled={false} allowVideo={true} handleError={this.handleError}/>
                    </div>          
                </div>                      
            </Modal>
        );
    }
}

ClaimAttachmentsModal.propTypes = {
    localization: Localization.propTypes.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    claim: PropTypes.object.isRequired,
    editClaim: PropTypes.func.isRequired,
};

export default ClaimAttachmentsModal;
